module.exports = __webpack_public_path__ + "images/fujian_banner03.jpg?cccd11c83d1df544e1646b66e443c137";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/fujian_banner03.jpg
// module id = 180
// module chunks = 1